import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// import { Link as RouterLink } from 'react-router-dom';
// we need to use a tags for now until we fully migrate all routes in app.v4
// react-router-dom's Link wont allow us to access pages that
import Link from 'components/Links/Link';

const WrapperDiv = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-style: normal;
  font-weight: 400;
  span.message {
    color: #33373d;
  }
  a.link {
    font-weight: 500;
    text-decoration: underline;
  }
`;

const ModalSubHeader = ({ message, to, linkTitle }) => {
  // const RouterLinkNode =
  //   path && linkTitle ? (
  //     <RouterLink className="link" to={to} data-testid="subheader-link">
  //       Router {linkTitle}
  //     </RouterLink>
  //   ) : null;

  const LinkNode =
    to && linkTitle ? (
      <Link className="link" to={to} data-testid="subheader-link">
        {' '}
        {linkTitle}{' '}
      </Link>
    ) : null;
  return (
    <WrapperDiv>
      <span className="message">{message}</span>
      {LinkNode}
    </WrapperDiv>
  );
};

ModalSubHeader.propTypes = {
  message: PropTypes.string,
  to: PropTypes.string,
  linkTitle: PropTypes.string
};

export default ModalSubHeader;
